export enum Type{
	BOM = 'BOM',
	VENDOR_PRODUCT = 'VENDOR_PRODUCT',
	CPE = 'CPE',
	EXT = 'EXT',
}
